'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkNetworkOnAblyTimeout = undefined;

var _buildError = require('conversations-infrastructure/errors/builders/buildError');

var _checkNetwork = require('conversations-infrastructure/http/clients/checkNetwork');

var REQUEST_TIMEOUT = 408;

var checkNetworkOnAblyTimeout = exports.checkNetworkOnAblyTimeout = function checkNetworkOnAblyTimeout(error) {
  if (error instanceof Error && error.statusCode === REQUEST_TIMEOUT) {
    return (0, _checkNetwork.checkNetwork)().then(function (_ref) {
      var online = _ref.online;

      if (online) throw error;
      throw (0, _buildError.buildError)('Network Unavailable', error);
    });
  }

  throw error;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/checkNetworkOnAblyTimeout.js
// module id = 788
// module chunks = 2 3